import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { collection, doc, getDoc, getDocs, addDoc, deleteDoc } from 'firebase/firestore';
import { firestore } from '_utils/firebase-app';
import * as QAService from '_services/qa-service';

// Async thunk to get pairs of questions and answers
export const getQAPairs = createAsyncThunk('qa/getQAPairs', async (airport) => {
  return await QAService.getQAPairs(airport);
});

// Async thunk to post a pair of question and answer
export const postQAPair = createAsyncThunk('qa/postQAPair', async ({ airport, question, answer }) => {
  return await QAService.postQAPair(airport, question, answer);
});

// Async thunk to delete a pair of question and answer
export const deleteQAPair = createAsyncThunk('qa/deleteQAPair', async ({ pairId, iata }) => {
  return await QAService.deleteQAPair(pairId, iata);
});
const initialState = {
  pairs: [],
  loading: false,
  error: null,
  question: '',
  answer: ''
}

const qaSlice = createSlice({
  name: 'qa',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setQuestion: (state, action) => {
      state.question = action.payload;
    },
    setAnswer: (state, action) => {
      state.answer = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQAPairs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQAPairs.fulfilled, (state, action) => {
        state.loading = false;
        state.pairs = action.payload;
      })
      .addCase(getQAPairs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(postQAPair.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postQAPair.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(postQAPair.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteQAPair.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteQAPair.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteQAPair.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default qaSlice.reducer;

// Selector to get the pairs of questions and answers
export const selectQAPairs = (state) => state.qa.pairs;
export const selectQALoading = (state) => state.qa.loading;
export const selectQAError = (state) => state.qa.error;
export const selectQuestion = (state) => state.qa.question;
export const selectAnswer = (state) => state.qa.answer;

export const { setQuestion, setAnswer, reset } = qaSlice.actions;
